// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../web/myagent/app/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../web/myagent/app/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * ConfirmDialog - Minimal styling with variant colors
 */

.realm-confirm-dialog {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.realm-confirm-dialog-header {
  text-align: center;
}

.realm-confirm-dialog-title {
  margin: 0;
  font-size: 20px;
  font-weight: 600;
  color: inherit;
}

.realm-confirm-dialog-body {
  text-align: center;
}

.realm-confirm-dialog-message {
  margin: 0;
  font-size: 14px;
  opacity: 0.8;
  line-height: 1.6;
}

.realm-confirm-dialog-footer {
  display: flex;
  gap: 12px;
  justify-content: center;
  padding-top: 8px;
}

.realm-confirm-dialog-button {
  padding: 10px 24px;
  border: none;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  min-width: 100px;
}

/* Cancel button */
.realm-confirm-dialog-button-cancel {
  background: rgba(0, 0, 0, 0.05);
  color: inherit;
  border: 1px solid rgba(0, 0, 0, 0.1);
}

.realm-confirm-dialog-button-cancel:hover {
  background: rgba(0, 0, 0, 0.1);
}

@media (prefers-color-scheme: dark) {
  .realm-confirm-dialog-button-cancel {
    background: rgba(255, 255, 255, 0.05);
    border-color: rgba(255, 255, 255, 0.1);
  }

  .realm-confirm-dialog-button-cancel:hover {
    background: rgba(255, 255, 255, 0.1);
  }
}

/* Confirm button base */
.realm-confirm-dialog-button-confirm {
  color: white;
}

/* Danger variant */
.realm-confirm-dialog-button-danger {
  background: linear-gradient(135deg, #ef4444, #dc2626);
  box-shadow: 0 4px 12px rgba(239, 68, 68, 0.3);
}

.realm-confirm-dialog-button-danger:hover {
  transform: translateY(-1px);
  box-shadow: 0 6px 20px rgba(239, 68, 68, 0.4);
}

.realm-confirm-dialog-button-danger:active {
  transform: translateY(0);
}

/* Warning variant */
.realm-confirm-dialog-button-warning {
  background: linear-gradient(135deg, #f59e0b, #d97706);
  box-shadow: 0 4px 12px rgba(245, 158, 11, 0.3);
}

.realm-confirm-dialog-button-warning:hover {
  transform: translateY(-1px);
  box-shadow: 0 6px 20px rgba(245, 158, 11, 0.4);
}

.realm-confirm-dialog-button-warning:active {
  transform: translateY(0);
}

/* Info variant */
.realm-confirm-dialog-button-info {
  background: linear-gradient(135deg, #3b82f6, #2563eb);
  box-shadow: 0 4px 12px rgba(59, 130, 246, 0.3);
}

.realm-confirm-dialog-button-info:hover {
  transform: translateY(-1px);
  box-shadow: 0 6px 20px rgba(59, 130, 246, 0.4);
}

.realm-confirm-dialog-button-info:active {
  transform: translateY(0);
}

/* Responsive */
@media (max-width: 768px) {
  .realm-confirm-dialog {
    gap: 16px;
  }

  .realm-confirm-dialog-footer {
    flex-direction: column-reverse;
  }

  .realm-confirm-dialog-button {
    width: 100%;
    padding: 12px;
  }
}
`, "",{"version":3,"sources":["webpack://./../../../packages/common/realm-ui/components/ConfirmDialog.css"],"names":[],"mappings":"AAAA;;EAEE;;AAEF;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA,kBAAkB;AAClB;EACE,+BAA+B;EAC/B,cAAc;EACd,oCAAoC;AACtC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE;IACE,qCAAqC;IACrC,sCAAsC;EACxC;;EAEA;IACE,oCAAoC;EACtC;AACF;;AAEA,wBAAwB;AACxB;EACE,YAAY;AACd;;AAEA,mBAAmB;AACnB;EACE,qDAAqD;EACrD,6CAA6C;AAC/C;;AAEA;EACE,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,wBAAwB;AAC1B;;AAEA,oBAAoB;AACpB;EACE,qDAAqD;EACrD,8CAA8C;AAChD;;AAEA;EACE,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,wBAAwB;AAC1B;;AAEA,iBAAiB;AACjB;EACE,qDAAqD;EACrD,8CAA8C;AAChD;;AAEA;EACE,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,wBAAwB;AAC1B;;AAEA,eAAe;AACf;EACE;IACE,SAAS;EACX;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,WAAW;IACX,aAAa;EACf;AACF","sourcesContent":["/**\n * ConfirmDialog - Minimal styling with variant colors\n */\n\n.realm-confirm-dialog {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n.realm-confirm-dialog-header {\n  text-align: center;\n}\n\n.realm-confirm-dialog-title {\n  margin: 0;\n  font-size: 20px;\n  font-weight: 600;\n  color: inherit;\n}\n\n.realm-confirm-dialog-body {\n  text-align: center;\n}\n\n.realm-confirm-dialog-message {\n  margin: 0;\n  font-size: 14px;\n  opacity: 0.8;\n  line-height: 1.6;\n}\n\n.realm-confirm-dialog-footer {\n  display: flex;\n  gap: 12px;\n  justify-content: center;\n  padding-top: 8px;\n}\n\n.realm-confirm-dialog-button {\n  padding: 10px 24px;\n  border: none;\n  border-radius: 6px;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  min-width: 100px;\n}\n\n/* Cancel button */\n.realm-confirm-dialog-button-cancel {\n  background: rgba(0, 0, 0, 0.05);\n  color: inherit;\n  border: 1px solid rgba(0, 0, 0, 0.1);\n}\n\n.realm-confirm-dialog-button-cancel:hover {\n  background: rgba(0, 0, 0, 0.1);\n}\n\n@media (prefers-color-scheme: dark) {\n  .realm-confirm-dialog-button-cancel {\n    background: rgba(255, 255, 255, 0.05);\n    border-color: rgba(255, 255, 255, 0.1);\n  }\n\n  .realm-confirm-dialog-button-cancel:hover {\n    background: rgba(255, 255, 255, 0.1);\n  }\n}\n\n/* Confirm button base */\n.realm-confirm-dialog-button-confirm {\n  color: white;\n}\n\n/* Danger variant */\n.realm-confirm-dialog-button-danger {\n  background: linear-gradient(135deg, #ef4444, #dc2626);\n  box-shadow: 0 4px 12px rgba(239, 68, 68, 0.3);\n}\n\n.realm-confirm-dialog-button-danger:hover {\n  transform: translateY(-1px);\n  box-shadow: 0 6px 20px rgba(239, 68, 68, 0.4);\n}\n\n.realm-confirm-dialog-button-danger:active {\n  transform: translateY(0);\n}\n\n/* Warning variant */\n.realm-confirm-dialog-button-warning {\n  background: linear-gradient(135deg, #f59e0b, #d97706);\n  box-shadow: 0 4px 12px rgba(245, 158, 11, 0.3);\n}\n\n.realm-confirm-dialog-button-warning:hover {\n  transform: translateY(-1px);\n  box-shadow: 0 6px 20px rgba(245, 158, 11, 0.4);\n}\n\n.realm-confirm-dialog-button-warning:active {\n  transform: translateY(0);\n}\n\n/* Info variant */\n.realm-confirm-dialog-button-info {\n  background: linear-gradient(135deg, #3b82f6, #2563eb);\n  box-shadow: 0 4px 12px rgba(59, 130, 246, 0.3);\n}\n\n.realm-confirm-dialog-button-info:hover {\n  transform: translateY(-1px);\n  box-shadow: 0 6px 20px rgba(59, 130, 246, 0.4);\n}\n\n.realm-confirm-dialog-button-info:active {\n  transform: translateY(0);\n}\n\n/* Responsive */\n@media (max-width: 768px) {\n  .realm-confirm-dialog {\n    gap: 16px;\n  }\n\n  .realm-confirm-dialog-footer {\n    flex-direction: column-reverse;\n  }\n\n  .realm-confirm-dialog-button {\n    width: 100%;\n    padding: 12px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
